import { RouterProvider } from 'react-router-dom'
import useRoutes from './hooks/useRoutes'

function App() {
  return <RouterProvider router={useRoutes()} />
}

export default App
